import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import Icon from "@mdi/react";
import { mdiCellphone, mdiFileDocumentOutline, mdiInformationOutline, mdiShieldAlertOutline } from "@mdi/js";

import config from "config";
import AppBar from "components/AppBar";
import PageLayout from "components/PageLayout";

export interface HelpProps {
  onBack?: () => void;
  onViewAppInfo: () => void;
}

function Help(props: HelpProps) {
  const { onBack, onViewAppInfo } = props;

  return (
    <PageLayout appBar={<AppBar title='Help' onBack={onBack} />}>
      <List>
        <ListItemButton href={config.links.website} rel='noopener noreferrer' target='_blank'>
          <ListItemIcon>
            <Icon path={mdiInformationOutline} title='Info' size={1} />
          </ListItemIcon>
          <ListItemText primary='About us' />
        </ListItemButton>

        {/* APP INFO */}
        <ListItemButton onClick={onViewAppInfo}>
          <ListItemIcon>
            <Icon path={mdiCellphone} size={1} />
          </ListItemIcon>
          <ListItemText primary='App info' />
        </ListItemButton>

        {/* PRIVACY POLICY */}
        <ListItemButton href={config.links.privacyPolicy} rel='noopener noreferrer' target='_blank'>
          <ListItemIcon>
            <Icon path={mdiShieldAlertOutline} title='Shield' size={1} />
          </ListItemIcon>
          <ListItemText primary='Privacy Policy' />
        </ListItemButton>

        {/* TERMS AND CONDITIONS */}
        <ListItemButton href={config.links.termsAndConditions} rel='noopener noreferrer' target='_blank'>
          <ListItemIcon>
            <Icon path={mdiFileDocumentOutline} title='File' size={1} />
          </ListItemIcon>
          <ListItemText primary='Terms and Conditions' />
        </ListItemButton>
      </List>
    </PageLayout>
  );
}

export default Help;
